
// site.css
import '@popperjs/core';

import './jquery.js';

import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';
import 'bootstrap';
import 'globalize';
import 'signalr';

import MarvlisApiProxy from './marvlis-api-proxy.js';
window["MarvlisApiProxy"] = MarvlisApiProxy;

import { EventHub } from './event-hub.js'
window["EventHub"] = EventHub;

import Cookies from 'js-cookie'
window["Cookies"] = Cookies;

import * as signalR from "@microsoft/signalr";
window["signalR"] = signalR;

// Required stylesheets
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';
import '@fortawesome/fontawesome-free/css/all.css';

// Custom CSS
import '../scss/bootstrap.css';
import '../scss/site.scss';
import '../scss/themes/base/all.css';



/*



            bundles.Add(new ScriptBundle("~/bundles/dimple").Include(
            "/Dashboard/Scripts/d3.v4.min.js",
            "/Dashboard/Scripts/dimple.v2.3.0.min.js"));
            

*/


//import 'jquery-validation';
//import 'jquery-validation-unobtrusive';


console.log('The \'site\' bundle has been loaded!');